import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { fetchMultipleCommentPages } from 'bundles/discussions/actions/ThreadDetailsActions';
import ListBody from 'bundles/discussions/components/ListBody';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import ReplyListItem from 'bundles/discussions/components/repliesList/ReplyListItem';
import { loadingStates } from 'bundles/discussions/constants';
import { replyPropType } from 'bundles/discussions/lib/propTypes';

import _t from 'i18n!nls/discussions';

class CommentPaginationContainer extends React.Component {
  static propTypes = {
    reply: replyPropType.isRequired,
    answerId: PropTypes.string,
    commentId: PropTypes.string,
    commentLoadingState: PropTypes.string,
    comments: PropTypes.array,
    commentPageRange: PropTypes.object,
    isQuestionLoaded: PropTypes.bool,
    forumLink: PropTypes.string,
    forumType: PropTypes.string,
    includeDeleted: PropTypes.bool,
    onDeleteClick: PropTypes.func,
    onDeleteSuccess: PropTypes.func,
    isReadOnlyAfterSessionEnd: PropTypes.bool,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof CommentPaginationContainer.contextTypes>;

  state = {
    loadingComments: false,
    focusOnReplyId: undefined,
  };

  componentWillMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { reply, answerId, commentId, forumType, includeDeleted } = this.props;

    // make sure that if we have a deep-linked comment, the comment is loaded.
    if (commentId && reply.topLevelForumAnswerId === answerId) {
      const { questionId } = reply;

      this.context.executeAction(fetchMultipleCommentPages, {
        questionId,
        answerId,
        userForumAnswerId: reply.id,
        startPage: 1,
        endPage: 100,
        forumType,
        includeDeleted,
      });
    }
  }

  componentWillReceiveProps(nextProps: $TSFixMe) {
    if (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'commentLoadingState' does not exist on t... Remove this comment to see the full error message
      this.props.commentLoadingState === loadingStates.LOADING &&
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'commentLoadingState' does not exist on t... Remove this comment to see the full error message
      this.props.commentLoadingState !== nextProps.commentLoadingState
    ) {
      this.setState({ loadingComments: false });
    }
  }

  componentDidUpdate(prevProps: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'comments' does not exist on t... Remove this comment to see the full error message
    const { comments } = this.props;

    // focus the latest comment anytime the number of comments increases
    if ((prevProps.comments?.length ?? 0) < comments?.length) {
      this.setState({
        focusOnReplyId: comments[comments.length - 1].id,
      });
    }
  }

  loadEarlierReplies = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { reply, commentPageRange, forumType, includeDeleted } = this.props;
    const { endPage } = commentPageRange;
    const { questionId } = reply;

    this.context.executeAction(fetchMultipleCommentPages, {
      questionId,
      forumType,
      includeDeleted,
      answerId: reply.topLevelForumAnswerId,
      userForumAnswerId: reply.id,
      startPage: endPage + 1,
      endPage: endPage + 1,
    });
    this.setState({ loadingComments: true });
  };

  render() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<... Remove this comment to see the full error message
      reply,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'comments' does not exist on type 'Readonly<... Remove this comment to see the full error message
      comments,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'commentLoadingState' does not exist on type 'Readonly<... Remove this comment to see the full error message
      commentLoadingState,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'answerId' does not exist on type 'Readonly<... Remove this comment to see the full error message
      answerId,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'commentId' does not exist on type 'Readonly<... Remove this comment to see the full error message
      commentId,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'commentPageRange' does not exist on type 'Readonly<... Remove this comment to see the full error message
      commentPageRange,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDeleteClick' does not exist on type 'Readonly<... Remove this comment to see the full error message
      onDeleteClick,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDeleteSuccess' does not exist on type 'Readonly<... Remove this comment to see the full error message
      onDeleteSuccess,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isReadOnlyAfterSessionEnd' does not exist on type 'Readonly<... Remove this comment to see the full error message
      isReadOnlyAfterSessionEnd,
    } = this.props;
    const isLoading = this.state.loadingComments || commentLoadingState === loadingStates.LOADING;
    // Don't use ListBody LOADING state, so that comments are still interactable while more are loading.
    const listBodyLoadingState = isLoading ? loadingStates.DONE : commentLoadingState;

    if (reply.childAnswerCount === 0) {
      return null;
    }

    return (
      <div className="rc-CommentPaginationContainer vertical-box">
        {commentPageRange.endPage < commentPageRange.totalPageCount && (
          <button className="secondary reply-load-button" onClick={this.loadEarlierReplies} disabled={isLoading}>
            {isLoading ? <span className="cif-spinner cif-spin" /> : _t('See earlier replies')}
          </button>
        )}
        <ListBody loadingState={listBodyLoadingState}>
          {comments &&
            comments.map((comment: $TSFixMe, index: $TSFixMe) => (
              <ReplyListItem
                reply={comment}
                key={comment.id}
                answerId={answerId}
                commentId={commentId}
                commentsEnabled={false}
                ref={comment.id}
                isFocused={comment.id === this.state.focusOnReplyId}
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'isQuestionLoaded' does not exist on type... Remove this comment to see the full error message
                isQuestionLoaded={this.props.isQuestionLoaded}
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumLink' does not exist on type 'Reado... Remove this comment to see the full error message
                forumLink={this.props.forumLink}
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumType' does not exist on type 'Reado... Remove this comment to see the full error message
                forumType={this.props.forumType}
                onDeleteClick={onDeleteClick}
                onDeleteSuccess={onDeleteSuccess}
                isReadOnlyAfterSessionEnd={isReadOnlyAfterSessionEnd}
              />
            ))}
        </ListBody>
      </div>
    );
  }
}

export default connectToStores(
  CommentPaginationContainer,
  ['ThreadDetailsStore', 'ApplicationStore', 'CourseMembershipStore'],
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type '{}'.
  ({ ThreadDetailsStore, ApplicationStore, CourseMembershipStore }, { reply }) => {
    return {
      comments: ThreadDetailsStore.getLoadedComments(reply.topLevelForumAnswerId),
      commentLoadingState: ThreadDetailsStore.commentLoadingState[reply.topLevelForumAnswerId] || loadingStates.LOADING,
      commentPageRange: ThreadDetailsStore.getCommentPageRange(reply.topLevelForumAnswerId),
      forumType: ThreadDetailsStore.forumType,
      includeDeleted: CourseMembershipStore.hasModerationRole() || ApplicationStore.isSuperuser(),
    };
  }
);
